/*
 * Route eligibility for the application's Admire presentation mode.
 * Used by the application shell.
 * Check the current pathname before exposing or applying Admire mode.
 * Example: const available = admireAvailableForPath(window.location.pathname);
 */

export function admireAvailableForPath(pathname) {
  const match = String(pathname || '').match(/^\/maps\/([^/]+)$/);
  return !match || match[1] === 'new';
}
